// removed by extract-text-webpack-plugin
module.exports = {"mainBox":"trXgCn36_jpRMUPwalwZ_","tipWord":"_2rMQt-dAmsQXk_O3rVOk_a","spinner":"_11Hmnx3bqsrZJm8LIQyAh1"};


//////////////////
// WEBPACK FOOTER
// ./src/frame/ui/Spinner/index.scss
// module id = 709
// module chunks = 12